










































































import Vue from 'vue';
import { FormFieldValidation, ModalHelpers, RouteHelpers } from '@/mixins';
import { DocuSignAdditionalDocumentFileCreateModel, BaseResultModel, MStoreConstants } from '@/types';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

export default Vue.extend({
  name: 'DocusignAddAdditionalDocument',
  mixins: [FormFieldValidation, ModalHelpers, RouteHelpers],
  data() {
    return {
      isLoading: false,
      additionalDocument: {} as DocuSignAdditionalDocumentFileCreateModel,
      submitIsLoading: false,
      fileTypeWhiteList: ''
    };
  },
  methods: {
    async onSubmit(this: any) {
      this.resetFormValidation();
      try {
        const isValid = await this.$validator.validate();
        if (!isValid || !this.validateFile()) {
          return;
        }
      } catch (error) {
        this.$log('Validation failed', error);
        return;
      }

      this.submitIsLoading = true;
      try {
        const result: BaseResultModel = await DocuSignConfigurationService.createAdditionalDocumentFileAsync({
          fileData: this.additionalDocument.fileData,
          description: this.additionalDocument.description
        } as DocuSignAdditionalDocumentFileCreateModel);
        if (result.hasNotification && !result.showToast) {
          this.addFormValidationError(result.notification);
          this.submitIsLoading = false;
          return;
        }
        SnotifyConfiguration.showSuccess('Additional document file created successfully.');
        this.setApplicationDirty(false);
        this.navigateToRoute('docusignAdditionalDocumentManagement');
      } catch (error) {
        this.addFormValidationError(error.notification);
      } finally {
        this.submitIsLoading = false;
      }
    },
    async onCancel(this: any) {
      this.$router.back();
    },
    validateFile(this: any): boolean {
      this.resetFormValidation();

      const file = this.additionalDocument.fileData;
      const fileSizeMB = Math.ceil(file.size / (1024 * 1024));
      if (!file || fileSizeMB > this.fileUploadSizeLimitMb) {
        this.addFormValidationError(`Please select a file not larger than ${this.fileUploadSizeLimitMb}MB`);
        return false;
      }

      return true;
    },
    resetValidation(this: any) {
      this.$validator.reset();
      this.resetFormValidation();
    },
    async initialise(this: any) {
      try {
        const result = await DocuSignConfigurationService.getFileTypeWhitelistAsync();
        if (result) {
          this.fileTypeWhiteList = result.map((type: string) => `.${type}`).join(',');
        }
      } catch (error) {
        this.$log('Error fetching the file type white list.');
      }
    }
  },
  mounted(this: any) {
    this.initialise();
  },
  computed: {
    fileUploadSizeLimitMb() {
      return Number(this.$route.params.fileUploadSizeLimitMb);
    },
    fileLabel(this: any) {
      return `File (max ${this.fileUploadSizeLimitMb}MB)`;
    },
    note(this: any) {
      return `File types supported by DocuSign are ${this.fileTypeWhiteList}.`;
    }
  },
  created(this: any) {
    this.APP_NAME = MStoreConstants.AppName;
  },
  components: {
    LoadingSpinner
  }
});
